"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizeValidation = exports.getPropertyRules = exports.setupModule = void 0;
const _ = __importStar(require("lodash"));
const vue_1 = __importDefault(require("vue"));
const debug_1 = __importDefault(require("debug"));
const vee_validate_1 = require("vee-validate");
const rules = __importStar(require("vee-validate/dist/rules"));
const ajv_formats_1 = __importDefault(require("ajv-formats"));
const ajv_1 = __importDefault(require("ajv"));
const gettext_1 = require("@integro/gettext");
const vee_validate_2 = require("vee-validate");
const core_1 = require("@integro/core");
vue_1.default.component('ValidationObserver', vee_validate_1.ValidationObserver);
vue_1.default.component('ValidationProvider', vee_validate_1.ValidationProvider);
function setupModule() {
    localizeValidation();
}
exports.setupModule = setupModule;
const RULES = rules;
Object.keys(RULES).forEach(rule => (0, vee_validate_1.extend)(rule, RULES[rule]));
const log = (0, debug_1.default)('itp:ui:validation');
const ajv = new ajv_1.default({
    allErrors: true,
    formats: {
        'media-range': true,
        'name-email': true,
        'time-delta': true,
        color: true
    }
});
(0, ajv_formats_1.default)(ajv);
let ajvInitialized = false;
(0, vee_validate_2.setInteractionMode)('eager');
(0, vee_validate_1.extend)('jsonSchema', {
    validate(value, args) {
        const valid = ajv.validate({ $ref: _.get(args, 'ref') }, _.set({}, _.get(args, 'field'), value));
        if (!valid && ajv.errors) {
            return ajv.errors[0].message;
        }
        return true;
    },
    params: ['ref', 'field']
});
function addSchemas(document) {
    if (document.components && document.components.schemas) {
        for (let key of Object.keys(document.components.schemas)) {
            if (!ajv.getSchema(key)) {
                log('Add schema %s', key);
                ajv.addSchema(document.components.schemas[key], key);
            }
        }
    }
}
function partialSchema(schema) {
    if (schema.properties) {
        const subs = [];
        for (let key of Object.keys(schema.properties)) {
            let properties = {};
            properties[key] = (0, core_1.deepCopy)(schema.properties[key]);
            if (properties[key].$ref) {
                properties[key].$ref = replaceRef(properties[key].$ref);
            }
            subs.push({
                $id: `#${key}`,
                type: 'object',
                properties,
                required: [key]
            });
        }
        return {
            type: 'object',
            allOf: subs
        };
    }
}
function replaceRef(value) {
    return value.replace('#/components/schemas/', '');
}
function getSchemas(data) {
    const converted = JSON.parse(JSON.stringify(data, (key, value) => {
        if (key === '$ref') {
            return replaceRef(value);
        }
        return value;
    }));
    return _.map(converted, (val, key) => ((val['$id'] = key), val));
}
function getJSONSchemaValidator(propertyName, property, schema, document) {
    if (!ajvInitialized && document.components && document.components.schemas) {
        log('Initializing schemas...');
        const schemas = getSchemas(document.components.schemas);
        ajv.addSchema(schemas);
        ajvInitialized = true;
    }
    const schemaKey = `Partial${schema.title}`;
    log('Get validator: #%s/%s', propertyName, schemaKey);
    let s = ajv.getSchema(schemaKey);
    if (!s) {
        const p = partialSchema(schema);
        if (p) {
            log('Add partial schema %s', schemaKey);
            ajv.addSchema(p, schemaKey);
        }
    }
    return {
        ref: `${schemaKey}#${propertyName}`,
        field: propertyName
    };
}
function getPropertyRules(propertyName, property, schema, document) {
    const result = {
        jsonSchema: getJSONSchemaValidator(propertyName, property, schema, document)
    };
    if (Array.isArray(schema.required) &&
        schema.required.indexOf(propertyName) > -1) {
        result['required'] = true;
    }
    if (property.enum) {
        result['oneOf'] = (0, core_1.deepCopy)(property.enum);
    }
    return result;
}
exports.getPropertyRules = getPropertyRules;
function localizeValidation() {
    (0, vee_validate_1.localize)({
        en: {
            messages: {
                alpha: (0, gettext_1.pgettext)('Validation', 'This field may only contain alphabetic characters'),
                alpha_num: (0, gettext_1.pgettext)('Validation', 'This field may only contain alpha-numeric characters'),
                alpha_dash: (0, gettext_1.pgettext)('Validation', 'This field may contain alpha-numeric characters as well as dashes and underscores'),
                alpha_spaces: (0, gettext_1.pgettext)('Validation', 'This field may only contain alphabetic characters as well as spaces'),
                between: (0, gettext_1.pgettext)('Validation', 'Value must be between {min} and {max}'),
                confirmed: (0, gettext_1.pgettext)('Validation', 'Confirmation does not match'),
                digits: (0, gettext_1.pgettext)('Validation', 'Value must be numeric and contain exactly {length} digits'),
                dimensions: (0, gettext_1.pgettext)('Validation', 'This field must be {width} pixels by {height} pixels'),
                email: (0, gettext_1.pgettext)('Validation', 'Value must be a valid email'),
                excluded: (0, gettext_1.pgettext)('Validation', 'This field is not a valid value'),
                ext: (0, gettext_1.pgettext)('Validation', 'This field is not a valid file'),
                image: (0, gettext_1.pgettext)('Validation', 'This field must be an image'),
                integer: (0, gettext_1.pgettext)('Validation', 'This field must be an integer'),
                length: (0, gettext_1.pgettext)('Validation', 'Field value must be {length} long'),
                max_value: (0, gettext_1.pgettext)('Validation', 'Value must be {max} or less'),
                max: (0, gettext_1.pgettext)('Validation', 'Field value may not be greater than {length} characters'),
                mimes: (0, gettext_1.pgettext)('Validation', 'This field must have a valid file type'),
                min_value: (0, gettext_1.pgettext)('Validation', 'Value must be {min} or more'),
                min: (0, gettext_1.pgettext)('Validation', 'Field value must be at least {length} characters length'),
                numeric: (0, gettext_1.pgettext)('Validation', 'This field may only contain numeric characters'),
                oneOf: (0, gettext_1.pgettext)('Validation', 'This field is not a valid value'),
                regex: (0, gettext_1.pgettext)('Validation', 'Invalid format'),
                required_if: (0, gettext_1.pgettext)('Validation', 'This field is required'),
                required: (0, gettext_1.pgettext)('Validation', 'This field is required'),
                size: (0, gettext_1.pgettext)('Validation', 'File size must be less than {size}KB'),
                double: (0, gettext_1.pgettext)('Validation', 'Value must be a valid decimal')
            }
        }
    });
}
exports.localizeValidation = localizeValidation;
//# sourceMappingURL=setup.js.map